export const ERROR_ALERT = 'showErrorAlert';
export const SUCCESS_ALERT = 'showSuccessAlert';
export const HIDE_ALERT = 'hideAlert';


export const showErrorAlert = (payload) => ({
    type: ERROR_ALERT,
    payload
});

export const showSuccessAlert = (payload) => ({
    type: SUCCESS_ALERT,
    payload
});

export const hideAlert = (payload) => ({
    type: HIDE_ALERT,
    payload
});
